import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Elements';
import HeaderNav from './HeaderNav';
import Icon from './Icons';
import Logo from '../../media/logo-horizontal.svg';
import createLogger from '../../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `Header.js`);

class Header extends React.Component {

  static role = `header`;

  static propTypes = {
    top: PropTypes.bool,
    simple: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.node,
    goBackText: PropTypes.string.isRequired,
    goBack: PropTypes.func,
    subhead: PropTypes.bool,
    smallHeader: PropTypes.bool,
  };
  static defaultProps = {
    goBackText: `Go Back`,
  };


  render() {
    const {
      top,
      title,
      simple,
      subhead,
      smallHeader,
      pageHeader,
      goBack,
      goBackText,
      children,
    } = this.props;

    if (top) {
      return (
        <header className="top">
          <Logo/>
          <HeaderNav/>
        </header>
      )
    }

    if (simple) {
      let hasChildren = React.Children.count(children) > 0;
      return (
        <header className="simple">
          <h2 className={'hide-wrap'}>{ title }</h2>
          { hasChildren && <aside>{ children }</aside> }
        </header>
      )
    }

    if (pageHeader) {
      return (
          <header className="simple">
            <div className={`page-header`}>
              <h2>{title}</h2>
            </div>
            <div className={`page-header-utils`}>
              { children }
            </div>
          </header>
      )
    }

    if (subhead) {
      return (
        <header className="simple">
          <div>
            <h6>{ children }</h6>
          </div>
        </header>
      )
    }

    if (smallHeader) {
      return (
        <header className="simple">
          <div>
            <h4>{title}</h4>
            <h5>{children}</h5>
          </div>
        </header>
      )
    }

    return (
      <header>
        <div className="title">
          {
            !!goBack ? (
              <Button onClick={goBack}
                      text type="back"
                      icon="back">
                <Icon.Back/>
                { goBackText }
              </Button>
            ) : null
          }
          <h2>{ title }</h2>
        </div>

        <aside>
          { children }
        </aside>
      </header>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/static/Header.js